import * as React from 'react'
import { Link } from 'gatsby'
import HeaderMenu from '../components/HeaderMenu/HeaderMenu'
import { withLayout, LayoutProps, menuItems } from '../components/Layout'
import { Segment, Container, Grid, Header, Icon, Button } from 'semantic-ui-react'
import FormModalButton from '../components/Form/Form'
import { isMobile } from 'react-device-detect'
import { CustomerReviewCards } from '../components/CustomerReviewCards/CustomerReviewCards'
import Bounce from 'react-reveal/Bounce'
import Gallery from '../components/Gallery/Gallery'

const ACCENT = '#E8A838'
const DARK = '#1B263B'
const MID = '#415A77'

const services = [
  {
    icon: 'car' as any,
    name: 'Driveways',
    desc: 'Custom concrete driveways built to last, enhancing curb appeal and durability.'
  },
  {
    icon: 'home' as any,
    name: 'Patios',
    desc: 'Beautiful outdoor living spaces designed and poured to your specifications.'
  },
  {
    icon: 'road' as any,
    name: 'Sidewalks',
    desc: 'Safe, smooth sidewalk installations for residential and commercial properties.'
  },
  {
    icon: 'building' as any,
    name: 'Foundations',
    desc: 'Solid concrete foundations that provide a reliable base for any structure.'
  },
  {
    icon: 'paint brush' as any,
    name: 'Decorative Concrete',
    desc: 'Stamped, stained, and decorative finishes that combine beauty with strength.'
  },
  {
    icon: 'industry' as any,
    name: 'Commercial',
    desc: 'Large-scale commercial concrete projects completed on time and on budget.'
  }
]

const IndexPage = (props: LayoutProps) => (
  <div>
    {/* ── HERO ── */}
    <Segment
      vertical
      textAlign="center"
      className="masthead"
      style={{
        backgroundImage: `url(https://images.unsplash.com/photo-1560780552-ba54683cb263?ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        height: isMobile ? '90vh' : '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.58)',
          zIndex: 1
        }}
      />

      {/* Nav sits on top of overlay */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10 }}>
        <HeaderMenu
          Link={Link}
          pathname={props.location.pathname}
          items={menuItems}
        />
      </div>

      {/* Hero content */}
      <Container style={{ position: 'relative', zIndex: 2 }}>
        <Header
          as="h1"
          style={{
            fontFamily: 'Oswald',
            color: '#fff',
            fontSize: isMobile ? '2.6em' : '4.2em',
            marginBottom: '0.2em',
            letterSpacing: '1px'
          }}
        >
          Elite Concrete &amp; Construction
        </Header>

        <Header
          as="h2"
          style={{
            fontFamily: 'Oswald',
            color: ACCENT,
            fontSize: isMobile ? '1.4em' : '2em',
            fontWeight: 400,
            marginTop: 0
          }}
        >
          Atlanta's Trusted Concrete Provider
        </Header>

        <p
          style={{
            fontFamily: 'Oswald',
            color: 'rgba(255,255,255,0.85)',
            fontSize: '1.25em',
            letterSpacing: '2px',
            marginBottom: '2em'
          }}
        >
          Driveways &nbsp;|&nbsp; Patios &nbsp;|&nbsp; Sidewalks &nbsp;|&nbsp; Foundations
        </p>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap' as any,
            gap: '1em',
            justifyContent: 'center'
          }}
        >
          <a href="tel:678-724-7984" style={{ textDecoration: 'none' }}>
            <Button
              size="large"
              style={{
                backgroundColor: ACCENT,
                color: '#fff',
                fontFamily: 'Oswald',
                fontSize: '1.1em',
                padding: '0.85em 1.8em',
                border: 'none'
              }}
            >
              <Icon name="phone" />
              678-724-7984
            </Button>
          </a>
          <FormModalButton />
        </div>
      </Container>
    </Segment>

    {/* ── TRUST BAR ── */}
    <Segment
      vertical
      style={{
        backgroundColor: DARK,
        padding: '1.2em 0'
      }}
    >
      <Container>
        <Grid columns={3} stackable textAlign="center">
          <Grid.Row>
            <Grid.Column>
              <p style={{ color: '#fff', fontFamily: 'Oswald', fontSize: '1.05em', margin: 0 }}>
                <Icon name="certificate" style={{ color: ACCENT }} />
                Licensed &amp; Insured
              </p>
            </Grid.Column>
            <Grid.Column>
              <p style={{ color: '#fff', fontFamily: 'Oswald', fontSize: '1.05em', margin: 0 }}>
                <Icon name="clock outline" style={{ color: ACCENT }} />
                15+ Years of Experience
              </p>
            </Grid.Column>
            <Grid.Column>
              <p style={{ color: '#fff', fontFamily: 'Oswald', fontSize: '1.05em', margin: 0 }}>
                <Icon name="dollar sign" style={{ color: ACCENT }} />
                Free Estimates Within 24 hrs
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>

    {/* ── SERVICES ── */}
    <Segment vertical style={{ padding: '5em 0', backgroundColor: '#f7f7f7' }}>
      <Container>
        <Header
          as="h2"
          textAlign="center"
          style={{
            fontFamily: 'Oswald',
            fontSize: '2.4em',
            color: DARK,
            marginBottom: '0.3em'
          }}
        >
          Our Services
        </Header>
        <p
          style={{
            textAlign: 'center',
            fontFamily: 'Oswald',
            color: '#666',
            fontSize: '1.1em',
            marginBottom: '2.5em'
          }}
        >
          Residential &amp; Commercial concrete work done right the first time.
        </p>

        <Grid columns={3} stackable textAlign="center">
          <Grid.Row>
            {services.map(s => (
              <Grid.Column key={s.name} style={{ marginBottom: '2em' }}>
                <Bounce left>
                  <div
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      padding: '2.2em 1.5em',
                      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                      height: '100%',
                      transition: 'box-shadow 0.2s'
                    }}
                  >
                    <Icon
                      name={s.icon}
                      size="huge"
                      style={{ color: MID, marginBottom: '0.5em' }}
                    />
                    <Header
                      as="h3"
                      style={{ fontFamily: 'Oswald', color: DARK, marginTop: '0.3em' }}
                    >
                      {s.name}
                    </Header>
                    <p style={{ fontFamily: 'Oswald', color: '#555', fontSize: '1em' }}>
                      {s.desc}
                    </p>
                  </div>
                </Bounce>
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>

    {/* ── ABOUT ── */}
    <Segment vertical style={{ padding: '5em 0', backgroundColor: '#fff' }}>
      <Container>
        <Grid stackable verticalAlign="middle">
          <Grid.Row>
            <Grid.Column width={8}>
              <Header as="h2" style={{ fontFamily: 'Oswald', color: DARK, fontSize: '2em' }}>
                About Elite Concrete
              </Header>
              <div
                style={{
                  width: '60px',
                  height: '4px',
                  backgroundColor: ACCENT,
                  marginBottom: '1.2em'
                }}
              />
              <p style={{ fontFamily: 'Oswald', color: '#555', fontSize: '1.1em', lineHeight: 1.7 }}>
                Elite Concrete and Construction, established by the Clark family in the summer of
                2010, has consistently upheld high standards within the concrete industry. This
                success is a direct result of our commitment to customer satisfaction and delivering
                superior quality work throughout Atlanta and the surrounding areas.
              </p>
              <p style={{ fontFamily: 'Oswald', color: '#555', fontSize: '1.1em', lineHeight: 1.7 }}>
                From small residential projects to large commercial installations, we bring the same
                level of craftsmanship and attention to detail to every job.
              </p>
            </Grid.Column>

            <Grid.Column width={6} floated="right">
              <div
                style={{
                  backgroundColor: DARK,
                  borderRadius: '8px',
                  padding: '2.5em',
                  color: '#fff'
                }}
              >
                <Header as="h3" style={{ fontFamily: 'Oswald', color: ACCENT, marginTop: 0 }}>
                  Get a Free Estimate
                </Header>
                <p style={{ fontFamily: 'Oswald', color: 'rgba(255,255,255,0.85)', marginBottom: '1em' }}>
                  Ready to start your project? Give us a call or send us a message.
                  We'll get back to you within 24 hours.
                </p>
                <p style={{ fontFamily: 'Oswald', marginBottom: '0.6em' }}>
                  <Icon name="phone" style={{ color: ACCENT }} />
                  <a href="tel:678-724-7984" style={{ color: '#fff', textDecoration: 'none' }}>
                    678-724-7984
                  </a>
                </p>
                <p style={{ fontFamily: 'Oswald', marginBottom: '1.5em' }}>
                  <Icon name="envelope" style={{ color: ACCENT }} />
                  <a
                    href="mailto:georgiaeliteconcrete@gmail.com"
                    style={{ color: '#fff', textDecoration: 'none' }}
                  >
                    georgiaeliteconcrete@gmail.com
                  </a>
                </p>
                <FormModalButton />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>

    {/* ── GALLERY ── */}
    <Segment vertical style={{ padding: '5em 0', backgroundColor: '#f7f7f7' }}>
      <Container fluid>
        <Header
          as="h2"
          textAlign="center"
          style={{
            fontFamily: 'Oswald',
            fontSize: '2.4em',
            color: DARK,
            marginBottom: '0.3em'
          }}
        >
          Our Recent Projects
        </Header>
        <p
          style={{
            textAlign: 'center',
            fontFamily: 'Oswald',
            color: '#666',
            fontSize: '1.1em',
            marginBottom: '2em'
          }}
        >
          Browse our work across Atlanta and the Southeast.
        </p>
        <Gallery />
      </Container>
    </Segment>

    {/* ── TESTIMONIALS ── */}
    <Segment vertical style={{ padding: '5em 0', backgroundColor: '#fff' }}>
      <Container>
        <Header
          as="h2"
          textAlign="center"
          style={{ fontFamily: 'Oswald', fontSize: '2.4em', color: DARK, marginBottom: '0.3em' }}
        >
          What Our Customers Say
        </Header>
        <p
          style={{
            textAlign: 'center',
            fontFamily: 'Oswald',
            color: '#666',
            fontSize: '1.1em',
            marginBottom: '2.5em'
          }}
        >
          We've helped homeowners and businesses throughout the Southeast bring their ideas to life.
        </p>
        <Grid stackable columns={3} centered>
          <Grid.Row centered>
            <CustomerReviewCards />
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>

    {/* ── CTA BANNER ── */}
    <Segment
      vertical
      textAlign="center"
      style={{ backgroundColor: ACCENT, padding: '4em 0' }}
    >
      <Header
        as="h2"
        style={{ fontFamily: 'Oswald', color: '#fff', fontSize: '2em', marginBottom: '0.5em' }}
      >
        Ready to Start Your Project?
      </Header>
      <p style={{ fontFamily: 'Oswald', color: 'rgba(255,255,255,0.9)', fontSize: '1.1em', marginBottom: '1.5em' }}>
        Call today for a free estimate — we respond within 24 hours.
      </p>
      <a href="tel:678-724-7984" style={{ textDecoration: 'none' }}>
        <Button
          size="large"
          style={{
            backgroundColor: DARK,
            color: '#fff',
            fontFamily: 'Oswald',
            fontSize: '1.2em',
            padding: '0.85em 2em'
          }}
        >
          <Icon name="phone" />
          678-724-7984
        </Button>
      </a>
    </Segment>
  </div>
)

export default withLayout(IndexPage)
